import Cart from './Cart.jsx';

export default Cart;


// WEBPACK FOOTER //
// ./src/components/Cart/index.jsx